
















import { UiTooltip } from './keen-ui';

export default {
  name: 'kpi-bar',
  props: {
    kpi: {
      type: Object, // { id: KpiEnum; percentage: number; label?: string; }
      required: true
    },
    totalPercentageValue: {
      type: Number,
      default: 100
    },
    animation: {
      type: Object, // { duration: number; delay?: number; appear?: boolean }
      default: () => ({ duration: 500 })
    }
  },
  components: {
    UiTooltip
  },
  computed: {
    tooltipText: function (): string {
      const percentageText = `${ this.kpi.percentage.toLocaleString(this.$epb.locale, { maximumFractionDigits: 3 }) }%`;
      if (!!this.kpi.label) {
        return `${ this.kpi.label } (${ percentageText })`;
      }
      return percentageText;
    }
  },
  data: function () {
    return {
      baseClass: 'epb-kpi-bar'
    };
  }
};
